import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

// Renders the in-progress freehand polygon during draw mode (P6.5/P6.6).
// Two visual states driven by `isPressed`:
//   - Pressed (drag in progress): open polyline through the cursor samples.
//   - Released (drag complete, awaiting Aplicar): closed translucent polygon
//     — same fill+stroke as the committed BoundaryOverlay so the preview
//     matches what the user will see post-commit.
//
// Imperative because vis.gl doesn't ship declarative Polyline / Polygon
// children — drop down to the raw Google Maps API via useMap(). Mounts as
// a child of MapPane's <GoogleMap>; the parent gates render on `isDrawing`
// so this only paints during draw mode.
const STROKE_COLOR = "#002B49";
const FILL_OPACITY = 0.1;
const STROKE_OPACITY = 0.9;
const STROKE_WEIGHT = 2;

const DrawingOverlay = ({ vertices, isPressed }) => {
    const map = useMap();

    useEffect(() => {
        if (!map || !vertices?.length) return;
        if (typeof window === "undefined" || !window.google?.maps) return;
        const gm = window.google.maps;

        let overlay = null;
        if (isPressed && vertices.length >= 2) {
            overlay = new gm.Polyline({
                path: vertices,
                strokeColor: STROKE_COLOR,
                strokeOpacity: STROKE_OPACITY,
                strokeWeight: STROKE_WEIGHT,
                clickable: false,
                map,
            });
        } else if (!isPressed && vertices.length >= 3) {
            overlay = new gm.Polygon({
                paths: vertices,
                strokeColor: STROKE_COLOR,
                strokeOpacity: STROKE_OPACITY,
                strokeWeight: STROKE_WEIGHT,
                fillColor: STROKE_COLOR,
                fillOpacity: FILL_OPACITY,
                clickable: false,
                map,
            });
        }

        return () => {
            if (overlay) overlay.setMap(null);
        };
    }, [map, vertices, isPressed]);

    return null;
};

export default DrawingOverlay;
